// this method limits object blocks to only those currently in scope
export default function findCloned(objects) {
  const targetObjects = objects.filter(childObject => childObject["is-cloned"]);
  return targetObjects || [];
}
